
// // import { paths } from 'src/routes/paths';
// // import { FaTasks } from 'react-icons/fa';
// // import { LiaMoneyCheckAltSolid } from 'react-icons/lia';
// // import { RiHomeSmileLine, RiBookMarkedLine } from 'react-icons/ri';
// // import { HiOutlineUser, HiOutlineUsers, HiOutlineUserPlus } from 'react-icons/hi2';
// // import { LuGraduationCap } from 'react-icons/lu';
// // import { PiBankDuotone, PiBell } from 'react-icons/pi';
// // import { BiWalletAlt, BiBuildingHouse, BiSolidBookAdd } from 'react-icons/bi';
// // import {
// //   TbBrandIntercom,
// //   TbReportAnalytics,
// //   TbCategory,
// //   TbCards,
// //   TbCalendarDue,
// // } from 'react-icons/tb';
// // import { IoStatsChartOutline } from 'react-icons/io5';
// // import { FaUserTie, FaCcAmazonPay } from 'react-icons/fa6';
// // import { AiOutlineExclamationCircle } from 'react-icons/ai';
// // import {
// //   MdOutlineCoPresent,
// //   MdOutlineVpnKey,
// //   MdOutlineBusinessCenter,
// //   MdGroups,
// //   MdOutlineCreateNewFolder,
// // } from 'react-icons/md';
// // import { GrSchedule, GrAnnounce, GrUpdate } from 'react-icons/gr';
// // import { GoDot } from 'react-icons/go';
// // import { useRouter } from 'src/routes/hook';
// // import { CgWebsite } from 'react-icons/cg';

// // // components
// // import SvgColor from 'src/components/svg-color';
// // import { useAuthContext } from 'src/auth/hooks';
// // import { useEffect, useState } from 'react';
// // import axios, { endpoints } from 'src/utils/axios';
// // import { hasPermission } from './checkpermission'; // <-- already defined by you

// // // ----------------------------------------------------------------------

// // const ICONS = {
// //   dashboard: <RiHomeSmileLine size={30} />,
// //   not: <PiBell size={30} />,
// //   interview: <TbBrandIntercom size={30} />,
// //   fee: <LiaMoneyCheckAltSolid size={30} />,
// //   student: <HiOutlineUser size={30} />,
// //   course: <LuGraduationCap size={30} />,
// //   batchs: <BiWalletAlt size={30} />,
// //   changebatch: <GrUpdate size={25}/>,
// //   category: <TbCategory size={30} />,
// //   role: <MdOutlineVpnKey size={26} />,
// //   attendance: <MdOutlineCoPresent size={30} />,
// //   courses: <TbCards size={30} />,
// //   status: <IoStatsChartOutline size={30} />,
// //   counsellor: <FaUserTie size={30} />,
// //   due: <TbCalendarDue size={30} />,
// //   mode: <FaCcAmazonPay size={25} />,
// //   bank: <BiBuildingHouse size={25} />,
// //   report: <TbReportAnalytics size={30} />,
// //   about: <AiOutlineExclamationCircle size={30} />,
// //   work: <MdOutlineBusinessCenter size={30} />,
// //   trainer: <HiOutlineUsers size={30} />,
// //   subject: <RiBookMarkedLine size={30} />,
// //   schedule: <GrSchedule size={30} />,
// //   addbatch: <MdOutlineCreateNewFolder size={30} />,
// //   payment: <PiBankDuotone size={30} />,
// //   batch: <MdGroups size={30} />,
// //   dot: <GoDot size={20} />,
// //   addcourse: <BiSolidBookAdd size={30} />,
// //   web: <CgWebsite size={30} />,
// //   task: <FaTasks size={22} />,
// //   announcement: <GrAnnounce size={25} />,
// //   users: <HiOutlineUserPlus size={30} />,
// // };

// // // ----------------------------------------------------------------------

// // export function useNavData() {
// //   const auth = useAuthContext();
// //   const router = useRouter();
// //   const { logout } = auth;

// //   const [getprofile, setProfile] = useState(false);
// //   const [roles, setRoles] = useState([]);

// //   const fetchData = async () => {
// //     try {
// //       const token = localStorage.getItem('accessToken');
// //       const user = localStorage.getItem('user');
// //       const userObj = user ? JSON.parse(user) : null;

// //       if (!token || !userObj?.id) throw new Error('Missing auth or user');

// //       const response = await axios.post(
// //         endpoints.auth.getProfile,
// //         { id: userObj.id },
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //         }
// //       );

// //       if (response?.data?.user) {
// //         setProfile(response.data.user);
// //       } else {
// //         throw new Error('Invalid response');
// //       }
// //     } catch (err) {
// //       console.error('fetchData error:', err.message || err);
// //       await logout();
// //       router.replace('/login');
// //       setProfile(false);
// //     }
// //   };
// //   const fetchRole = async () => {
// //     try {
// //       const response = await axios.post(endpoints.user.role);
// //       if (response && response.data) {
// //         const filteredRoles = response.data.filter((ro) => ro.id !== 1);
// //         setRoles(filteredRoles);
// //       }
// //     } catch (err) {
// //       // // console.log(err);
// //     }
// //   };
// //   const getBankName = (batchId) => {
// //     // const batch = bank.find((modeItem) => modeItem.id === batchId);
// //     const batch = roles.find((modeItem) => String(modeItem.id) === String(batchId));

// //     return batch ? batch.name : 'FINXL';
// //   };

// //   useEffect(() => {
// //     fetchData();
// //     fetchRole();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const role = auth.user?.roleType;
// //   const permissions = auth?.user?.permissions || [];
// //   const roleName = getBankName(role);

// //   const menuData = [
// //     {
// //       subheader: roleName,
// //       items: [
// //         // {
// //         //   title: 'Dashboard',
// //         //   path: paths.dashboard.root,
// //         //   icon: ICONS.dashboard,
// //         //   permissionKey: 'dashboard.View',
// //         // },
// //         {
// //           title: [1, 2, 3, 4, 6, 7].includes(auth.user?.roleType) ? 'Dashboard' : 'Profile',
// //           path: paths.dashboard.root,
// //           icon: ICONS.dashboard,
// //           permissionKey: 'dashboard.View',
// //         },

// //         {
// //           title: 'Announcement',
// //           // path: paths.dashboard.announcement.root,
// //           icon: ICONS.announcement,
// //           permissionKey: 'announcements.View',
// //           children: [
// //             {
// //               title: 'New Announcement',
// //               path: paths.dashboard.announcement.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'announcements.List',
// //             },
// //             {
// //               title: 'Notification',
// //               path: paths.dashboard.studentannouncement.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'announcements.Notification',
// //             },

// //             // {
// //             //   title: 'New Registration',
// //             //   // path: paths.dashboard.registration.root,
// //             //   icon: ICONS.dot,
// //             //    permissionKey: 'registration.List',
// //             // },
// //             {
// //               title: 'Holiday List',
// //               path: paths.dashboard.holiday.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'announcements.Holiday',
// //             },
// //             // {
// //             //   title: 'Performance Report',
// //             //   // path: paths.dashboard.placedstudent.root,
// //             //   icon: ICONS.dot,
// //             //   permissionKey: 'announcements.Performance report',
// //             // },
// //             // {
// //             //   title: 'Attendance Report ',
// //             //   // path: paths.dashboard.placedstudent.root,
// //             //   icon: ICONS.dot,
// //             //   permissionKey: 'announcements.Attendance report',
// //             // },
// //           ],
// //         },
// //         {
// //           title: 'Reports',
// //           // path: paths.dashboard.reports.root,
// //           icon: ICONS.report,
// //           permissionKey: 'reports.List',
// //           children: [
// //             {
// //               title: 'Enrollment Report',
// //               path: paths.dashboard.reportenrolled.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'reports.Enrollment',
// //             },
// //             {
// //               title: 'Payment Report',
// //               path: paths.dashboard.reportpayment.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'reports.Payment',
// //             },
// //             {
// //               title: 'Attendance Report',
// //               path: paths.dashboard.reports.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'reports.Attendance',
// //             },
// //             {
// //               title: 'Performance Report',
// //               path: paths.dashboard.reportperformance.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'reports.Performance',
// //             },
// //             // {
// //             //   title: 'Student Placed',
// //             //   permissionKey: 'placed.List',
// //             //   path: paths.dashboard.placedstudent.root,
// //             //   icon: ICONS.dot,
// //             // },
// //           ],
// //         },

// //         {
// //           title: 'Student Attendance',
// //           path: paths.dashboard.studentattendance.root,
// //           icon: ICONS.attendance,
// //           permissionKey: 'AttendanceDetails.List',
// //         },

// //         {
// //           title: 'Student Database',
// //           // path: paths.dashboard.students.root,
// //           icon: ICONS.student,
// //           permissionKey: 'students.View',
// //           children: [
// //             {
// //               title: 'Enrolled Students',
// //               path: paths.dashboard.students.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'students.List',
// //             },
// //             {
// //               title: 'New Registration',
// //               path: paths.dashboard.registration.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'registration.List',
// //             },
// //             {
// //               title: 'Students Enquiry',
// //               path: paths.dashboard.enquiry.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'enquiry.List',
// //             },
// //             {
// //               title: 'Student Placed',
// //               permissionKey: 'placed.List',
// //               path: paths.dashboard.placedstudent.root,
// //               icon: ICONS.dot,
// //             },
// //           ],
// //         },
// //         {
// //           title: 'Fees Management',
// //           // path: paths.dashboard.fee.root,
// //           icon: ICONS.fee,
// //           children: [
// //             {
// //               title: 'Paid Fees',
// //               path: paths.dashboard.fee.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'paidfee.List',
// //             },
// //             {
// //               title: 'Due Fees',
// //               path: paths.dashboard.due.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'duefee.List',
// //             },
// //             {
// //               title: 'Outstanding Fees',
// //               path: paths.dashboard.outstanding.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'outstandingfee.List',
// //             },
// //           ],
// //         },
// //         // {
// //         //   title: 'Batches',
// //         //   path: paths.dashboard.batchs.root,
// //         //   icon: ICONS.batchs,
// //         //   children: [
// //         //     // { title: 'Add Batch', path: paths.dashboard.batchs.root, icon: ICONS.dot },
// //         //     // { title: 'Add Schedule', path: paths.dashboard.batchs.schedule, icon: ICONS.dot },
// //         //     { title: 'Current Batches ', path: paths.dashboard.batchs.root, icon: ICONS.dot },
// //         //     {
// //         //       title: 'Completed Batches',
// //         //       path: paths.dashboard.batchs.schedule,
// //         //       icon: ICONS.dot,
// //         //     },
// //         //     // {title: 'Add Duration',path:paths.dashboard.batchs.duration}
// //         //   ],
// //         // },
// //         {
// //           title: 'Resume Building',
// //           path: paths.dashboard.internalhr.root,
// //           icon: ICONS.users,
// //           permissionKey: 'resume.List',
// //         },
// //         {
// //           title: 'Mock Interviews',
// //           path: paths.dashboard.mockdetails.root,
// //           icon: ICONS.interview,
// //           permissionKey: 'mockdetails.List',
// //         },

// //         {
// //           title: 'Interview Calls',
// //           path: paths.dashboard.eligiblestudent.root,
// //           icon: ICONS.interview,
// //           permissionKey: 'interview.List',
// //         },
// //         {
// //           title: 'Daily Task',
// //           // path: paths.dashboard.admintask.root,
// //           icon: ICONS.task,
// //           permissionKey: 'dailytask.List',
// //           children: [
// //             {
// //               title: 'Delegate Tasks',
// //               path: paths.dashboard.delegated.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'delegatedtask.List',
// //             },
// //             {
// //               title: 'User Daily Tasks',
// //               path: paths.dashboard.task.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'dailytask.List',
// //             },
// //           ],
// //         },

// //         {
// //           title: 'CRM',
// //           path: paths.dashboard.lead.root,
// //           icon: ICONS.web,
// //           children: [
// //             {
// //               title: 'All Leads',
// //               path: paths.dashboard.lead.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'crm.AllLeads',
// //             },
// //             { title: 'SEO', icon: ICONS.dot, permissionKey: 'crm.SEO' },
// //             { title: 'Social Media', icon: ICONS.dot, permissionKey: 'crm.Social' },
// //             { title: 'Follow-ups', icon: ICONS.dot, permissionKey: 'crm.Follow' },

// //             // { title: 'Work Experience', path: paths.dashboard.work_experience.root, icon: ICONS.dot },
// //           ],
// //         },
// //         {
// //           title: auth.user?.roleType === 4 ? 'Trainer Profile' : 'Trainer/Mentors',
// //           path:
// //             auth.user?.roleType === 4
// //               ? paths.dashboard.trainer.profile
// //               : paths.dashboard.trainer.root,
// //           icon: ICONS.trainer,
// //           permissionKey: auth.user?.roleType === 4 ? 'trainerprofile.Profile' : 'trainers.List',
// //         },

// //         // {
// //         //   title: 'Trainer/Mentors',
// //         //   path: paths.dashboard.trainer.root,
// //         //   icon: ICONS.trainer,
// //         //   permissionKey: 'trainers.List',

// //         // },
// //         {
// //           title: 'Assignments',
// //           icon: ICONS.work,
// //           permissionKey:
// //             auth.user?.roleType === 5 ? 'assignments.StudentView' : 'assignments.TrainerView',
// //           path:
// //             auth.user?.roleType === 5
// //               ? paths.dashboard.studentassign.root
// //               : paths.dashboard.trainerassignment.root,
// //         },
// //         // {
// //         //   title: 'Assignments',
// //         //   path: paths.dashboard.trainerassignment.root,
// //         //   icon: ICONS.work,
// //         //   permissionKey: 'trainers.Assignments',
// //         // },
// //         {
// //           title: 'Masters',
// //           // path: paths.dashboard.user.root,
// //           icon: ICONS.dashboard,
// //           children: [
// //             {
// //               title: 'Add Users',
// //               path: paths.dashboard.user.root,
// //               icon: ICONS.users,
// //               permissionKey: 'users.List',
// //             },
// //             {
// //               title: 'Add Role',
// //               path: paths.dashboard.role.root,
// //               icon: ICONS.role,
// //               permissionKey: 'roles.List',
// //             },
// //             {
// //               title: 'Update/Change Batch',
// //               path: paths.dashboard.upateBatch.root,
// //               icon: ICONS.changebatch,
// //               permissionKey: 'updatebatch.List',
// //             },
// //             // {
// //             //   title: 'Add Trainers',
// //             //   path: paths.dashboard.trainer.root,
// //             //   icon: ICONS.trainer,
// //             //   permissionKey: 'trainers.List',
// //             // },
// //             {
// //               title: 'Add Companies',
// //               path: paths.dashboard.company.root,
// //               icon: ICONS.bank,
// //               permissionKey: 'company.List',
// //             },
// //             {
// //               title: 'How did you know about us',
// //               path: paths.dashboard.aboutus.root,
// //               icon: ICONS.about,
// //               permissionKey: 'aboutus.List',
// //             },
// //           ],
// //         },

// //         {
// //           title: 'Batches',
// //           // path: paths.dashboard.batchs.root,
// //           icon: ICONS.batchs,
// //           permissionKey: 'batches.List',
// //           children: [
// //             {
// //               title: 'Add Batches',
// //               path: paths.dashboard.batchs.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'batches.List',
// //             },
// //             {
// //               title: 'Add Schedules',
// //               path: paths.dashboard.batchs.schedule,
// //               icon: ICONS.dot,
// //               permissionKey: 'schedule.List',
// //             },
// //           ],
// //         },

// //         {
// //           title: 'Course',
// //           // path: paths.dashboard.course.root,
// //           icon: ICONS.course,
// //           permissionKey: 'courses.View',
// //           children: [
// //             {
// //               title: 'Add Modes',
// //               path: paths.dashboard.coursemode.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'coursemode.List',
// //             },
// //             {
// //               title: 'Add Categories',
// //               path: paths.dashboard.category.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'category.List',
// //             },
// //             {
// //               title: 'Add Subjects',
// //               path: paths.dashboard.subjects.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'subjects.List',
// //             },
// //             {
// //               title: 'Add Course',
// //               path: paths.dashboard.course.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'courses.List',
// //             },
// //           ],
// //         },

// //         {
// //           title: 'Fees',
// //           // path: paths.dashboard.paymentbanks.root,
// //           icon: ICONS.payment,
// //           permissionKey: 'feestructure.List',
// //           children: [
// //             {
// //               title: 'Add Payment Banks',
// //               path: paths.dashboard.paymentbanks.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'banks.List',
// //             },
// //             {
// //               title: 'Add Payment Modes',
// //               path: paths.dashboard.paymentmodes.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'paymentmode.List',
// //             },

// //             {
// //               title: 'Setup Fees Structure',
// //               path: paths.dashboard.setFee.root,
// //               icon: ICONS.dot,
// //               permissionKey: 'feestructure.List',
// //             },
// //           ],
// //         },
// //       ],
// //     },
// //   ];

// //   const filterWithPermission = (items = []) =>
// //     items
// //       .filter((item) => !item.permissionKey || hasPermission(permissions, item.permissionKey, role))
// //       .map((item) => ({
// //         ...item,
// //         children: item.children ? filterWithPermission(item.children) : undefined,
// //       }))
// //       .filter((item) => !item.children || item.children.length > 0);

// //   const filteredData = menuData.map((section) => ({
// //     ...section,
// //     items: filterWithPermission(section.items),
// //   }));

// //   return filteredData;
// // }

// import { paths } from 'src/routes/paths';
// import { FaTasks } from 'react-icons/fa';
// import { LiaMoneyCheckAltSolid } from 'react-icons/lia';
// import { RiHomeSmileLine, RiBookMarkedLine } from 'react-icons/ri';
// import { HiOutlineUser, HiOutlineUsers, HiOutlineUserPlus } from 'react-icons/hi2';
// import { LuGraduationCap } from 'react-icons/lu';
// import { PiBankDuotone, PiBell } from 'react-icons/pi';
// import { BiWalletAlt, BiBuildingHouse, BiSolidBookAdd } from 'react-icons/bi';
// import {
//   TbBrandIntercom,
//   TbReportAnalytics,
//   TbCategory,
//   TbCards,
//   TbCalendarDue,
// } from 'react-icons/tb';
// import { IoStatsChartOutline } from 'react-icons/io5';
// import { FaUserTie, FaCcAmazonPay } from 'react-icons/fa6';
// import { AiOutlineExclamationCircle } from 'react-icons/ai';
// import {
//   MdOutlineCoPresent,
//   MdOutlineVpnKey,
//   MdPostAdd ,
//   MdOutlineBusinessCenter,
//   MdGroups,
//   MdOutlineCreateNewFolder,
// } from 'react-icons/md';
// import { GrSchedule, GrAnnounce, GrUpdate } from 'react-icons/gr';
// import { GoDot } from 'react-icons/go';
// import { useRouter } from 'src/routes/hook';
// import { CgWebsite } from 'react-icons/cg';

// // components
// import SvgColor from 'src/components/svg-color';
// import { useAuthContext } from 'src/auth/hooks';
// import { useEffect, useState } from 'react';
// import axios, { endpoints } from 'src/utils/axios';
// import { hasPermission } from './checkpermission'; // <-- already defined by you

// // ----------------------------------------------------------------------

// const ICONS = {
//   dashboard: <RiHomeSmileLine size={30} />,
//   not: <PiBell size={30} />,
//   interview: <TbBrandIntercom size={30} />,
//   fee: <LiaMoneyCheckAltSolid size={30} />,
//   student: <HiOutlineUser size={30} />,
//   course: <LuGraduationCap size={30} />,
//   batchs: <BiWalletAlt size={30} />,
//   changebatch: <GrUpdate size={25}/>,
//   category: <TbCategory size={30} />,
//   role: <MdOutlineVpnKey size={26} />,
//   attendance: <MdOutlineCoPresent size={30} />,
//   courses: <TbCards size={30} />,
//   status: <IoStatsChartOutline size={30} />,
//   counsellor: <FaUserTie size={30} />,
//   due: <TbCalendarDue size={30} />,
//   mode: <FaCcAmazonPay size={25} />,
//   bank: <BiBuildingHouse size={25} />,
//   report: <TbReportAnalytics size={30} />,
//   about: <AiOutlineExclamationCircle size={30} />,
//   work: <MdOutlineBusinessCenter size={30} />,
//   trainer: <HiOutlineUsers size={30} />,
//   subject: <RiBookMarkedLine size={30} />,
//   schedule: <GrSchedule size={30} />,
//   job: <MdPostAdd size={30} />,
//   addbatch: <MdOutlineCreateNewFolder size={30} />,
//   payment: <PiBankDuotone size={30} />,
//   batch: <MdGroups size={30} />,
//   dot: <GoDot size={20} />,
//   addcourse: <BiSolidBookAdd size={30} />,
//   web: <CgWebsite size={30} />,
//   task: <FaTasks size={22} />,
//   announcement: <GrAnnounce size={25} />,
//   users: <HiOutlineUserPlus size={30} />,
// };

// // ----------------------------------------------------------------------

// export function useNavData() {
//   const auth = useAuthContext();
//   const router = useRouter();
//   const { logout } = auth;

//   const [getprofile, setProfile] = useState(false);
//   const [roles, setRoles] = useState([]);

//   const fetchData = async () => {
//     try {
//       const token = localStorage.getItem('accessToken');
//       const user = localStorage.getItem('user');
//       const userObj = user ? JSON.parse(user) : null;

//       if (!token || !userObj?.id) throw new Error('Missing auth or user');

//       const response = await axios.post(
//         endpoints.auth.getProfile,
//         { id: userObj.id },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response?.data?.user) {
//         setProfile(response.data.user);
//       } else {
//         throw new Error('Invalid response');
//       }
//     } catch (err) {
//       console.error('fetchData error:', err.message || err);
//       await logout();
//       router.replace('/login');
//       setProfile(false);
//     }
//   };
//   const fetchRole = async () => {
//     try {
//       const response = await axios.post(endpoints.user.role);
//       if (response && response.data) {
//         const filteredRoles = response.data.filter((ro) => ro.id !== 1);
//         setRoles(filteredRoles);
//       }
//     } catch (err) {
//       // // console.log(err);
//     }
//   };
//   const getBankName = (batchId) => {
//     // const batch = bank.find((modeItem) => modeItem.id === batchId);
//     const batch = roles.find((modeItem) => String(modeItem.id) === String(batchId));

//     return batch ? batch.name : 'FINXL';
//   };

//   useEffect(() => {
//     fetchData();
//     fetchRole();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const role = auth.user?.roleType;
//   const permissions = auth?.user?.permissions || [];
//   const roleName = getBankName(role);

//   const menuData = [
//     {
//       subheader: roleName,
//       items: [
//         // {
//         //   title: 'Dashboard',
//         //   path: paths.dashboard.root,
//         //   icon: ICONS.dashboard,
//         //   permissionKey: 'dashboard.View',
//         // },
//         {
//           title: [1, 2, 3, 4, 6, 7].includes(auth.user?.roleType) ? 'Dashboard' : 'Profile',
//           path: paths.dashboard.root,
//           icon: ICONS.dashboard,
//           permissionKey: 'dashboard.View',
//         },
      
//         {
//           title: 'Announcement',
//           // path: paths.dashboard.announcement.root,
//           icon: ICONS.announcement,
//           permissionKey: 'announcements.View',
//           children: [
//             {
//               title: 'New Announcement',
//               path: paths.dashboard.announcement.root,
//               icon: ICONS.dot,
//               permissionKey: 'announcements.List',
//             },
//             {
//               title: 'Notification',
//               path: paths.dashboard.studentannouncement.root,
//               icon: ICONS.dot,
//               permissionKey: 'announcements.Notification',
//             },

//             // {
//             //   title: 'New Registration',
//             //   // path: paths.dashboard.registration.root,
//             //   icon: ICONS.dot,
//             //    permissionKey: 'registration.List',
//             // },
//             {
//               title: 'Holiday List',
//               path: paths.dashboard.holiday.root,
//               icon: ICONS.dot,
//               permissionKey: 'announcements.Holiday',
//             },
//             // {
//             //   title: 'Performance Report',
//             //   // path: paths.dashboard.placedstudent.root,
//             //   icon: ICONS.dot,
//             //   permissionKey: 'announcements.Performance report',
//             // },
//             // {
//             //   title: 'Attendance Report ',
//             //   // path: paths.dashboard.placedstudent.root,
//             //   icon: ICONS.dot,
//             //   permissionKey: 'announcements.Attendance report',
//             // },
//           ],
//         },
//        {
//           title: 'Job Post',
//           path: paths.dashboard.jobpost.root,
//           icon: ICONS.job,
//           permissionKey: 'jobpost.List',
//         },
//         {
//           title: 'Reports',
//           // path: paths.dashboard.reports.root,
//           icon: ICONS.report,
//           permissionKey: 'reports.List',
//           children: [
//             {
//               title: 'Enrollment Report',
//               path: paths.dashboard.reportenrolled.root,
//               icon: ICONS.dot,
//               permissionKey: 'reports.Enrollment',
//             },
//             {
//               title: 'Payment Report',
//               path: paths.dashboard.reportpayment.root,
//               icon: ICONS.dot,
//               permissionKey: 'reports.Payment',
//             },
//             {
//               title: 'Attendance Report',
//               path: paths.dashboard.reports.root,
//               icon: ICONS.dot,
//               permissionKey: 'reports.Attendance',
//             },
//             {
//               title: 'Performance Report',
//               path: paths.dashboard.reportperformance.root,
//               icon: ICONS.dot,
//               permissionKey: 'reports.Performance',
//             },
//             // {
//             //   title: 'Student Placed',
//             //   permissionKey: 'placed.List',
//             //   path: paths.dashboard.placedstudent.root,
//             //   icon: ICONS.dot,
//             // },
//           ],
//         },

//         {
//           title: 'Student Attendance',
//           path: paths.dashboard.studentattendance.root,
//           icon: ICONS.attendance,
//           permissionKey: 'AttendanceDetails.List',
//         },

//         {
//           title: 'Student Database',
//           // path: paths.dashboard.students.root,
//           icon: ICONS.student,
//           permissionKey: 'students.View',
//           children: [
//             {
//               title: 'Enrolled Students',
//               path: paths.dashboard.students.root,
//               icon: ICONS.dot,
//               permissionKey: 'students.List',
//             },
//             {
//               title: 'New Registration',
//               path: paths.dashboard.registration.root,
//               icon: ICONS.dot,
//               permissionKey: 'registration.List',
//             },
//             {
//               title: 'Students Enquiry',
//               path: paths.dashboard.enquiry.root,
//               icon: ICONS.dot,
//               permissionKey: 'enquiry.List',
//             },
//             {
//               title: 'Student Placed',
//               permissionKey: 'placed.List',
//               path: paths.dashboard.placedstudent.root,
//               icon: ICONS.dot,
//             },
//           ],
//         },
//         {
//           title: 'Fees Management',
//           // path: paths.dashboard.fee.root,
//           icon: ICONS.fee,
//           children: [
//             {
//               title: 'Paid Fees',
//               path: paths.dashboard.fee.root,
//               icon: ICONS.dot,
//               permissionKey: 'paidfee.List',
//             },
//             {
//               title: 'Due Fees',
//               path: paths.dashboard.due.root,
//               icon: ICONS.dot,
//               permissionKey: 'duefee.List',
//             },
//             {
//               title: 'Outstanding Fees',
//               path: paths.dashboard.outstanding.root,
//               icon: ICONS.dot,
//               permissionKey: 'outstandingfee.List',
//             },
//           ],
//         },
//         // {
//         //   title: 'Batches',
//         //   path: paths.dashboard.batchs.root,
//         //   icon: ICONS.batchs,
//         //   children: [
//         //     // { title: 'Add Batch', path: paths.dashboard.batchs.root, icon: ICONS.dot },
//         //     // { title: 'Add Schedule', path: paths.dashboard.batchs.schedule, icon: ICONS.dot },
//         //     { title: 'Current Batches ', path: paths.dashboard.batchs.root, icon: ICONS.dot },
//         //     {
//         //       title: 'Completed Batches',
//         //       path: paths.dashboard.batchs.schedule,
//         //       icon: ICONS.dot,
//         //     },
//         //     // {title: 'Add Duration',path:paths.dashboard.batchs.duration}
//         //   ],
//         // },
//         {
//           title: 'Resume Building',
//           path: paths.dashboard.internalhr.root,
//           icon: ICONS.users,
//           permissionKey: 'resume.List',
//         },
//         {
//           title: 'Mock Interviews',
//           path: paths.dashboard.mockdetails.root,
//           icon: ICONS.interview,
//           permissionKey: 'mockdetails.List',
//         },

//         {
//           title: 'Interview Calls',
//           path: paths.dashboard.eligiblestudent.root,
//           icon: ICONS.interview,
//           permissionKey: 'interview.List',
//         },
//         {
//           title: 'Daily Task',
//           // path: paths.dashboard.admintask.root,
//           icon: ICONS.task,
//           permissionKey: 'dailytask.List',
//           children: [
//             {
//               title: 'Delegate Tasks',
//               path: paths.dashboard.delegated.root,
//               icon: ICONS.dot,
//               permissionKey: 'delegatedtask.List',
//             },
//             {
//               title: 'User Daily Tasks',
//               path: paths.dashboard.task.root,
//               icon: ICONS.dot,
//               permissionKey: 'dailytask.List',
//             },
//           ],
//         },

//         {
//           title: 'CRM',
//           path: paths.dashboard.lead.root,
//           icon: ICONS.web,
//           children: [
//             {
//               title: 'All Leads',
//               path: paths.dashboard.lead.root,
//               icon: ICONS.dot,
//               permissionKey: 'crm.AllLeads',
//             },
//             { title: 'SEO', icon: ICONS.dot, permissionKey: 'crm.SEO' },
//             { title: 'Social Media', icon: ICONS.dot, permissionKey: 'crm.Social' },
//             { title: 'Follow-ups', icon: ICONS.dot, permissionKey: 'crm.Follow' },
//               {
//               title: 'How did you know about us',
//               path: paths.dashboard.aboutus.root,
//               icon: ICONS.dot,
//               permissionKey: 'aboutus.List',
//             },

//             // { title: 'Work Experience', path: paths.dashboard.work_experience.root, icon: ICONS.dot },
//           ],
//         },
//         {
//           title: auth.user?.roleType === 4 ? 'Trainer Profile' : 'Trainer/Mentors',
//           path:
//             auth.user?.roleType === 4
//               ? paths.dashboard.trainer.profile
//               : paths.dashboard.trainer.root,
//           icon: ICONS.trainer,
//           permissionKey: auth.user?.roleType === 4 ? 'trainerprofile.Profile' : 'trainers.List',
//         },

//         // {
//         //   title: 'Trainer/Mentors',
//         //   path: paths.dashboard.trainer.root,
//         //   icon: ICONS.trainer,
//         //   permissionKey: 'trainers.List',

//         // },
//         {
//           title: 'Assignments',
//           icon: ICONS.work,
//           permissionKey:
//             auth.user?.roleType === 5 ? 'assignments.StudentView' : 'assignments.TrainerView',
//           path:
//             auth.user?.roleType === 5
//               ? paths.dashboard.studentassign.root
//               : paths.dashboard.trainerassignment.root,
//         },
//         // {
//         //   title: 'Assignments',
//         //   path: paths.dashboard.trainerassignment.root,
//         //   icon: ICONS.work,
//         //   permissionKey: 'trainers.Assignments',
//         // },
//         {
//           title: 'Masters',
//           // path: paths.dashboard.user.root,
//           icon: ICONS.dashboard,
//           children: [
//             {
//               title: 'Add Users',
//               path: paths.dashboard.user.root,
//               icon: ICONS.users,
//               permissionKey: 'users.List',
//             },
//             {
//               title: 'Add Role',
//               path: paths.dashboard.role.root,
//               icon: ICONS.role,
//               permissionKey: 'roles.List',
//             },
//             {
//               title: 'Update/Change Batch',
//               path: paths.dashboard.upateBatch.root,
//               icon: ICONS.changebatch,
//               permissionKey: 'updatebatch.List',
//             },
//             // {
//             //   title: 'Add Trainers',
//             //   path: paths.dashboard.trainer.root,
//             //   icon: ICONS.trainer,
//             //   permissionKey: 'trainers.List',
//             // },
//             {
//               title: 'Add Companies',
//               path: paths.dashboard.company.root,
//               icon: ICONS.bank,
//               permissionKey: 'company.List',
//             },
          
//           ],
//         },

//         {
//           title: 'Batches',
//           // path: paths.dashboard.batchs.root,
//           icon: ICONS.batchs,
//           permissionKey: 'batches.List',
//           children: [
//             {
//               title: 'Add Batches',
//               path: paths.dashboard.batchs.root,
//               icon: ICONS.dot,
//               permissionKey: 'batches.List',
//             },
//             {
//               title: 'Add Schedules',
//               path: paths.dashboard.batchs.schedule,
//               icon: ICONS.dot,
//               permissionKey: 'schedule.List',
//             },
//           ],
//         },

//         {
//           title: 'Course',
//           // path: paths.dashboard.course.root,
//           icon: ICONS.course,
//           permissionKey: 'courses.View',
//           children: [
//             {
//               title: 'Add Modes',
//               path: paths.dashboard.coursemode.root,
//               icon: ICONS.dot,
//               permissionKey: 'coursemode.List',
//             },
//             {
//               title: 'Add Categories',
//               path: paths.dashboard.category.root,
//               icon: ICONS.dot,
//               permissionKey: 'category.List',
//             },
//             {
//               title: 'Add Subjects',
//               path: paths.dashboard.subjects.root,
//               icon: ICONS.dot,
//               permissionKey: 'subjects.List',
//             },
//             {
//               title: 'Add Course',
//               path: paths.dashboard.course.root,
//               icon: ICONS.dot,
//               permissionKey: 'courses.List',
//             },
//           ],
//         },

//         {
//           title: 'Fees',
//           // path: paths.dashboard.paymentbanks.root,
//           icon: ICONS.payment,
//           permissionKey: 'feestructure.List',
//           children: [
//             {
//               title: 'Add Payment Banks',
//               path: paths.dashboard.paymentbanks.root,
//               icon: ICONS.dot,
//               permissionKey: 'banks.List',
//             },
//             {
//               title: 'Add Payment Modes',
//               path: paths.dashboard.paymentmodes.root,
//               icon: ICONS.dot,
//               permissionKey: 'paymentmode.List',
//             },

//             {
//               title: 'Setup Fees Structure',
//               path: paths.dashboard.setFee.root,
//               icon: ICONS.dot,
//               permissionKey: 'feestructure.List',
//             },
//           ],
//         },
//       ],
//     },
//   ];

//   const filterWithPermission = (items = []) =>
//     items
//       .filter((item) => !item.permissionKey || hasPermission(permissions, item.permissionKey, role))
//       .map((item) => ({
//         ...item,
//         children: item.children ? filterWithPermission(item.children) : undefined,
//       }))
//       .filter((item) => !item.children || item.children.length > 0);

//   const filteredData = menuData.map((section) => ({
//     ...section,
//     items: filterWithPermission(section.items),
//   }));

//   return filteredData;
// }
import { paths } from 'src/routes/paths';
import { FaTasks } from 'react-icons/fa';
import { LiaMoneyCheckAltSolid } from 'react-icons/lia';
import { RiHomeSmileLine, RiBookMarkedLine } from 'react-icons/ri';
import { HiOutlineUser, HiOutlineUsers, HiOutlineUserPlus } from 'react-icons/hi2';
import { LuGraduationCap,LuMailPlus } from 'react-icons/lu';
import { PiBankDuotone, PiBell } from 'react-icons/pi';
import { BiWalletAlt, BiBuildingHouse, BiSolidBookAdd ,BiSupport} from 'react-icons/bi';

import {
  TbBrandIntercom,
  TbReportAnalytics,
  TbCategory,
  TbCards,
  TbBrandZoom ,
  TbCalendarDue,
} from 'react-icons/tb';
import { IoStatsChartOutline, IoLocationOutline} from 'react-icons/io5';
import { FaUserTie, FaCcAmazonPay ,FaQuestion} from 'react-icons/fa6';
import { CiWallet } from "react-icons/ci"
import { AiOutlineExclamationCircle,AiOutlineAppstoreAdd  } from 'react-icons/ai';
import {
  MdOutlineCoPresent,
  MdOutlineVpnKey,
  MdPostAdd,
  MdOutlineBusinessCenter,
  MdGroups,
  MdOutlineCreateNewFolder,
} from 'react-icons/md';
import { GrSchedule, GrAnnounce, GrUpdate } from 'react-icons/gr';
import { GoDot } from 'react-icons/go';
import { useRouter } from 'src/routes/hook';
import { CgWebsite } from 'react-icons/cg';

import SvgColor from 'src/components/svg-color';
import { useAuthContext } from 'src/auth/hooks';
import { useEffect, useState } from 'react';
import axios, { endpoints } from 'src/utils/axios';
import { useNavigate } from 'react-router';
import { hasPermission } from './checkpermission'; 


// ----------------------------------------------------------------------

const ICONS = {
  dashboard: <RiHomeSmileLine size={30} />,
  not: <PiBell size={30} />,
  ques: <FaQuestion size={26} />,
  interview: <TbBrandIntercom size={30} />,
  fee: <LiaMoneyCheckAltSolid size={30} />,
  student: <HiOutlineUser size={30} />,
  course: <LuGraduationCap size={30} />,
  mails: <LuMailPlus size={30} />,
  batchs: <BiWalletAlt size={30} />,
  prefloc: <IoLocationOutline  size={30} />,
  changebatch: <GrUpdate size={18} />,
  category: <TbCategory size={30} />,
  role: <MdOutlineVpnKey size={22} />,
  zoom: <TbBrandZoom size={22} />,
  attendance: <MdOutlineCoPresent size={28} />,
  courses: <TbCards size={30} />,
  wallet:  <CiWallet size={30} />,
  status: <IoStatsChartOutline size={30} />,
  counsellor: <FaUserTie size={30} />,
  due: <TbCalendarDue size={30} />,
  mode: <FaCcAmazonPay size={25} />,
  bank: <BiBuildingHouse size={25} />,
  report: <TbReportAnalytics size={30} />,
  support: <BiSupport size={30} />,
  apps: <AiOutlineAppstoreAdd size={30} />,
  about: <AiOutlineExclamationCircle size={30} />,
  work: <MdOutlineBusinessCenter size={30} />,
  trainer: <HiOutlineUsers size={30} />,
  subject: <RiBookMarkedLine size={30} />,
  schedule: <GrSchedule size={30} />,
  job: <MdPostAdd size={30} />,
  addbatch: <MdOutlineCreateNewFolder size={30} />,
  payment: <PiBankDuotone size={30} />,
  batch: <MdGroups size={30} />,
  dot: <GoDot size={20} />,
  addcourse: <BiSolidBookAdd size={30} />,
  web: <CgWebsite size={30} />,
  task: <FaTasks size={22} />,
  announcement: <GrAnnounce size={25} />,
  users: <HiOutlineUserPlus size={30} />,
};


// eslint-disable-next-line react/prop-types
const TitleWithBadge = ({ title, count }) => (
  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
    <span>{title}</span>
    {count > 0 && (
      <span
  style={{
    marginLeft: 6,
    background: '#7068FF',
    color: '#fff',
    borderRadius: '50%',
    width: 19,
    height: 19,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
   
  }}
>
  {count}
</span>
     
    )}
  </span>
);

// ----------------------------------------------------------------------

export function useNavData() {
  const auth = useAuthContext();
  const router = useRouter();
  const { logout } = auth;
    const navigate = useNavigate();

  const redirectToView = (row) => {

    const roleType = auth?.user?.roleType;
    const routeWithState = { state: row };
    navigate(paths.dashboard.studentannouncement.root, routeWithState);
   
  };

  const [getprofile, setProfile] = useState(false);
  const [roles, setRoles] = useState([]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const user = localStorage.getItem('user');
      const userObj = user ? JSON.parse(user) : null;

      if (!token || !userObj?.id) throw new Error('Missing auth or user');

      const response = await axios.post(
        endpoints.auth.getProfile,
        { id: userObj.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.user) {
        setProfile(response.data.user);
      } else {
        throw new Error('Invalid response');
      }
    } catch (err) {
      console.error('fetchData error:', err.message || err);
      await logout();
      router.replace('/login');
      setProfile(false);
    }
  };
    const [newAnnouncements, setNewAnnouncements] = useState(0);
  const [newRegistrations, setNewRegistrations] = useState(0);
   const [newAdmissions, setNewAdmissions] = useState(0);
    const [newEnquiries, setNewEnquiries] = useState(0);
     const [newPlacements, setNewPlacements] = useState(0);
      const [newDoubts, setNewDoubts] = useState(0);
            const [newRewards, setNewRewards] = useState(0);

  
  const fetchCounts = async () => {
     try {
          const response = await axios.post(`${endpoints.announcement.getNotif}${auth.user.id}`);
          if (response && response.data) {
            setNewAnnouncements(response.data?.announcements);
            
          }
        } catch (err) {
          // // console.log(err);
        }
        try {
          const sendData ={
            id:auth.user.id,
            roleType: auth.user.roleType
          }
          const response = await axios.post(`${endpoints.student.countview}`,sendData);
  
             
          if (response && response.data) {
            setNewRegistrations(response.data?.registerStudents || 0)
            setNewAdmissions(response.data?.newAdmissions|| 0)
            setNewEnquiries(response.data?.newEnquiries || 0)
            setNewPlacements(response.data?.placements || 0)
            setNewDoubts(response.data?.pendingDoubts || 0)
            setNewRewards(response.data?.referralRewards || 0)
          }
        } catch (err) {
          // // console.log(err);
        }
    // try {
    //   const token = localStorage.getItem('accessToken');
    //   const res = await axios.get('/api/counts', {
    //     headers: { Authorization: `Bearer ${token}` },
    //   });
    //   // Example response: { newAnnouncements: 5, newRegistrations: 3 }
    //   // setNewAnnouncements(res.data.newAnnouncements || 0);
    //   setNewRegistrations(res.data.newRegistrations || 0);
    // } catch (err) {
    //   console.error(err);
    // }
  };
  const fetchRole = async () => {
    try {
      const response = await axios.post(endpoints.user.role);
      if (response && response.data) {
        const filteredRoles = response.data.filter((ro) => ro.id !== 1);
        setRoles(filteredRoles);
      }
    } catch (err) {
      // // console.log(err);
    }
  };
  const getBankName = (batchId) => {
    // const batch = bank.find((modeItem) => modeItem.id === batchId);
    const batch = roles.find((modeItem) => String(modeItem.id) === String(batchId));

    return batch ? batch.name : 'FINXL';
  };

  useEffect(() => {
    fetchData();
    fetchCounts();
    fetchRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const role = auth.user?.roleType;
  const permissions = auth?.user?.permissions || [];
  const roleName = getBankName(role);

  const menuData = [
    {
      subheader: roleName,
      items: [
        // {
        //   title: 'Dashboard',
        //   path: paths.dashboard.root,
        //   icon: ICONS.dashboard,
        //   permissionKey: 'dashboard.View',
        // },
        {
          title: [1, 2, 3, 4, 6, 7].includes(auth.user?.roleType) ? 'Dashboard' : 'Profile',
          path: paths.dashboard.root,
          icon: ICONS.dashboard,
          permissionKey: 'dashboard.View',
        },

        {
          title: 'Announcement',
          // path: paths.dashboard.announcement.root,
          icon: ICONS.announcement,
          permissionKey: 'announcements.View',
          children: [
            {
              title: 'New Announcement',
              path: paths.dashboard.announcement.root,
              icon: ICONS.dot,
              permissionKey: 'announcements.List',
            },
           {
  title: <TitleWithBadge title="Notification" count={newAnnouncements?.length} />,
  path: paths.dashboard.studentannouncement.root,
  icon: ICONS.dot,
  permissionKey: 'announcements.Notification',
},

            // {
            //   title: 'New Registration',
            //   // path: paths.dashboard.registration.root,
            //   icon: ICONS.dot,
            //    permissionKey: 'registration.List',
            // },
            {
              title: 'Holiday List',
              path: paths.dashboard.holiday.root,
              icon: ICONS.dot,
              permissionKey: 'announcements.Holiday',
            },
            // {
            //   title: 'Performance Report',
            //   // path: paths.dashboard.placedstudent.root,
            //   icon: ICONS.dot,
            //   permissionKey: 'announcements.Performance report',
            // },
            // {
            //   title: 'Attendance Report ',
            //   // path: paths.dashboard.placedstudent.root,
            //   icon: ICONS.dot,
            //   permissionKey: 'announcements.Attendance report',
            // },
          ],
        },
        {
              title: 'Zoom Meetings',
              path: paths.dashboard.zoom_details.root,
              icon: ICONS.zoom,
              permissionKey: 'zoom.List',
            },
        {
          title: 'Job Post',
          path: paths.dashboard.jobpost.root,
          icon: ICONS.job,
          permissionKey: 'jobPost.List',
        },
        {
          title: 'Reports',
          // path: paths.dashboard.reports.root,
          icon: ICONS.report,
          permissionKey: 'reports.List',
          children: [
            {
              title: 'Enrollment Report',
              path: paths.dashboard.reportenrolled.root,
              icon: ICONS.dot,
              permissionKey: 'reports.Enrollment',
            },
            {
              title: 'Payment Report',
              path: paths.dashboard.reportpayment.root,
              icon: ICONS.dot,
              permissionKey: 'reports.Payment',
            },
            {
              title: 'Attendance Report',
              path: paths.dashboard.reports.root,
              icon: ICONS.dot,
              permissionKey: 'reports.Attendance',
            },
            {
              title: 'Review Report',
              path: paths.dashboard.reportreview.root,
              icon: ICONS.dot,
              permissionKey: 'reports.DocReview',
            },
            {
              title: 'Performance Report',
              path: paths.dashboard.reportperformance.root,
              icon: ICONS.dot,
              permissionKey: 'reports.Performance',
            },
            // {
            //   title: 'Student Placed',
            //   permissionKey: 'placed.List',
            //   path: paths.dashboard.placedstudent.root,
            //   icon: ICONS.dot,
            // },
          ],
        },
        {
          title: <TitleWithBadge title="Help Desk" count={newDoubts} />,
          path: paths.dashboard.helpdesk.root,
          icon: ICONS.support,
          permissionKey: 'helpdesk.List',
        },
        {
          title: 'Student Attendance',
          path: paths.dashboard.studentattendance.root,
          icon: ICONS.attendance,
          permissionKey: 'AttendanceDetails.List',
        },

        {
          title: 'Student Database',
          // path: paths.dashboard.students.root,
          icon: ICONS.student,
          permissionKey: 'students.View',
          children: [
            {
              title: <TitleWithBadge title="Enrolled Students" count={newAdmissions} />,
              path: paths.dashboard.students.root,
              icon: ICONS.dot,
              permissionKey: 'students.List',
            },
            {
              title:  <TitleWithBadge title="New Registration" count={newRegistrations} />,
              path: paths.dashboard.registration.root,
              icon: ICONS.dot,
              permissionKey: 'registration.List',
            },
            {
              title: <TitleWithBadge title="Students Enquiry" count={newEnquiries} />, 
              path: paths.dashboard.enquiry.root,
              icon: ICONS.dot,
              permissionKey: 'enquiry.List',
            },
            {
              title: <TitleWithBadge title="Student Placed" count={newPlacements} />, 
              permissionKey: 'placed.List',
              path: paths.dashboard.placedstudent.root,
              icon: ICONS.dot,
            },
          ],
        },
        {
          title: 'Fees Management',
          // path: paths.dashboard.fee.root,
          icon: ICONS.fee,
          children: [
            {
              title: 'Paid Fees',
              path: paths.dashboard.fee.root,
              icon: ICONS.dot,
              permissionKey: 'paidfee.List',
            },
            {
              title: 'Due Fees',
              path: paths.dashboard.due.root,
              icon: ICONS.dot,
              permissionKey: 'duefee.List',
            },
            {
              title: 'Outstanding Fees',
              path: paths.dashboard.outstanding.root,
              icon: ICONS.dot,
              permissionKey: 'outstandingfee.List',
            },
          ],
        },
        // {
        //   title: 'Batches',
        //   path: paths.dashboard.batchs.root,
        //   icon: ICONS.batchs,
        //   children: [
        //     // { title: 'Add Batch', path: paths.dashboard.batchs.root, icon: ICONS.dot },
        //     // { title: 'Add Schedule', path: paths.dashboard.batchs.schedule, icon: ICONS.dot },
        //     { title: 'Current Batches ', path: paths.dashboard.batchs.root, icon: ICONS.dot },
        //     {
        //       title: 'Completed Batches',
        //       path: paths.dashboard.batchs.schedule,
        //       icon: ICONS.dot,
        //     },
        //     // {title: 'Add Duration',path:paths.dashboard.batchs.duration}
        //   ],
        // },
        {
          title: 'Resume Building',
          path: paths.dashboard.internalhr.root,
          icon: ICONS.users,
          permissionKey: 'resume.List',
        },
        {
          title: 'Mock Interviews',
          path: paths.dashboard.mockdetails.root,
          icon: ICONS.interview,
          permissionKey: 'mockdetails.List',
        },

        {
          title: 'Interview Calls',
          path: paths.dashboard.eligiblestudent.root,
          icon: ICONS.interview,
          permissionKey: 'interview.List',
        },
        {
          title: 'Daily Task',
          // path: paths.dashboard.admintask.root,
          icon: ICONS.task,
          permissionKey: 'dailytask.List',
          children: [
            {
              title: 'Delegate Tasks',
              path: paths.dashboard.delegated.root,
              icon: ICONS.dot,
              permissionKey: 'delegatedtask.List',
            },
            {
              title: 'User Daily Tasks',
              path: paths.dashboard.task.root,
              icon: ICONS.dot,
              permissionKey: 'dailytask.List',
            },
          ],
        },
         {
          title: <TitleWithBadge title="Refer & Earn" count={newRewards} />,
          path: paths.dashboard.reward.root,
          icon: ICONS.wallet,
          permissionKey: 'refer&earn.List',
        },
         {
          title: 'Send Mail',
          path: paths.dashboard.mails.root,
          icon: ICONS.mails,
          permissionKey: 'SendMail.Add',
        },
        //   {
        //   title: 'Refer & Earn',
        //   // path: paths.dashboard.admintask.root,
        //   icon: ICONS.wallet,
        //   permissionKey: 'refer&earn.ListReward',
        //   children: [
        //     {
        //       title: 'Reward',
        //       path: paths.dashboard.reward.add,
        //       icon: ICONS.dot,
        //       permissionKey: 'refer&earn.ListReward',
        //     },
        //   ],
        // },

        {
          title: 'CRM',
          path: paths.dashboard.lead.root,
          icon: ICONS.web,
          children: [
            {
              title: 'All Leads',
              path: paths.dashboard.lead.root,
              icon: ICONS.dot,
              permissionKey: 'crm.AllLeads',
            },
            { title: 'SEO', icon: ICONS.dot, permissionKey: 'crm.SEO' },
            { title: 'Social Media', icon: ICONS.dot, permissionKey: 'crm.Social' },
            { title: 'Follow-ups', icon: ICONS.dot, permissionKey: 'crm.Follow' },
            

            // { title: 'Work Experience', path: paths.dashboard.work_experience.root, icon: ICONS.dot },
          ],
        },
        {
          title: auth.user?.roleType === 4 ? 'Trainer Profile' : 'Trainers',
          path:
            auth.user?.roleType === 4
              ? paths.dashboard.trainer.profile
              : paths.dashboard.trainer.root,
          icon: ICONS.trainer,
          permissionKey: auth.user?.roleType === 4 ? 'trainerprofile.Profile' : 'trainers.List',
        },
        {
          title: auth.user?.roleType === 8 ? 'Mentor Profile' : 'Mentors',
          path:
            auth.user?.roleType === 8
              ? paths.dashboard.mentor.profile
              : paths.dashboard.mentor.root,
          icon: ICONS.trainer,
          permissionKey: auth.user?.roleType === 8 ? 'mentor.Profile' : 'mentor.List',
        },

        // {
        //   title: 'Trainer/Mentors',
        //   path: paths.dashboard.trainer.root,
        //   icon: ICONS.trainer,
        //   permissionKey: 'trainers.List',

        // },
        {
          title: 'Assignments',
          icon: ICONS.work,
          permissionKey:
            auth.user?.roleType === 5 ? 'assignments.StudentView' : 'assignments.TrainerView',
          path:
            auth.user?.roleType === 5
              ? paths.dashboard.studentassign.root
              : paths.dashboard.trainerassignment.root,
        },
        // {
        //   title: 'Assignments',
        //   path: paths.dashboard.trainerassignment.root,
        //   icon: ICONS.work,
        //   permissionKey: 'trainers.Assignments',
        // },
        {
          title: 'Masters',
          // path: paths.dashboard.user.root,
          icon: ICONS.dashboard,
          children: [
            {
              title: 'Add Users',
              path: paths.dashboard.user.root,
              icon: ICONS.users,
              permissionKey: 'users.List',
            },
            {
              title: 'Add Role',
              path: paths.dashboard.role.root,
              icon: ICONS.role,
              permissionKey: 'roles.List',
            },
             {
              title: 'Add Applications',
              path: paths.dashboard.applications.root,
              icon: ICONS.apps,
              permissionKey: 'applications.List',
            },
             {
              title: 'Legal Pages',
              path: paths.dashboard.pages.root,
              icon: ICONS.job,
              permissionKey: 'legalPages.List',
            },
             {
              title: 'Zoom Accounts',
              path: paths.dashboard.zoom_accounts.root,
              icon: ICONS.zoom,
              permissionKey: 'zoomAccount.List',
            },
            {
              title: 'Update/Change Batch',
              path: paths.dashboard.upateBatch.root,
              icon: ICONS.changebatch,
              permissionKey: 'updatebatch.List',
            },
            {
              title: 'How did you know about us',
              path: paths.dashboard.aboutus.root,
              icon: ICONS.dot,
              permissionKey: 'aboutus.List',
            },
            // {
            //   title: 'Add Trainers',
            //   path: paths.dashboard.trainer.root,
            //   icon: ICONS.trainer,
            //   permissionKey: 'trainers.List',
            // },
            {
              title: 'Add Companies',
              path: paths.dashboard.company.root,
              icon: ICONS.bank,
              permissionKey: 'company.List',
            },
             {
              title: 'Preferred Location',
              path: paths.dashboard.preferredlocation.root,
              icon: ICONS.prefloc,
              permissionKey: 'preferredLocation.List',
            },{
              title: 'Q & A',
              path: paths.dashboard.qa.root,
              icon: ICONS.ques,
              permissionKey: 'q&a.List',
            },
          ],
        },
        {
          title: 'Batches',
          // path: paths.dashboard.batchs.root,
          icon: ICONS.batchs,
          permissionKey: 'batches.List',
          children: [
            {
              title: 'Add Batches',
              path: paths.dashboard.batchs.root,
              icon: ICONS.dot,
              permissionKey: 'batches.List',
            },
            {
              title: 'Add Schedules',
              path: paths.dashboard.batchs.schedule,
              icon: ICONS.dot,
              permissionKey: 'schedule.List',
            },
          ],
        },

        {
          title: 'Course',
          // path: paths.dashboard.course.root,
          icon: ICONS.course,
          permissionKey: 'courses.View',
          children: [
            {
              title: 'Add Modes',
              path: paths.dashboard.coursemode.root,
              icon: ICONS.dot,
              permissionKey: 'coursemode.List',
            },
            {
              title: 'Add Categories',
              path: paths.dashboard.category.root,
              icon: ICONS.dot,
              permissionKey: 'category.List',
            },
            {
              title: 'Add Subjects',
              path: paths.dashboard.subjects.root,
              icon: ICONS.dot,
              permissionKey: 'subjects.List',
            },
            {
              title: 'Add Course',
              path: paths.dashboard.course.root,
              icon: ICONS.dot,
              permissionKey: 'courses.List',
            },
          ],
        },

        {
          title: 'Fees',
          // path: paths.dashboard.paymentbanks.root,
          icon: ICONS.payment,
          permissionKey: 'feestructure.List',
          children: [
            {
              title: 'Add Payment Banks',
              path: paths.dashboard.paymentbanks.root,
              icon: ICONS.dot,
              permissionKey: 'banks.List',
            },
            {
              title: 'Add Payment Modes',
              path: paths.dashboard.paymentmodes.root,
              icon: ICONS.dot,
              permissionKey: 'paymentmode.List',
            },

            {
              title: 'Setup Fees Structure',
              path: paths.dashboard.setFee.root,
              icon: ICONS.dot,
              permissionKey: 'feestructure.List',
            },
          ],
        },
      ],
    },
  ];

  const filterWithPermission = (items = []) =>
    items
      .filter((item) => !item.permissionKey || hasPermission(permissions, item.permissionKey, role))
      .map((item) => ({
        ...item,
        children: item.children ? filterWithPermission(item.children) : undefined,
      }))
      .filter((item) => !item.children || item.children.length > 0);

  const filteredData = menuData.map((section) => ({
    ...section,
    items: filterWithPermission(section.items),
  }));

  return filteredData;
}
